module.exports = __webpack_public_path__ + "static/img/app-store.ec3b8152.svg";